/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoringTimeUsageDTO
 */
export interface MonitoringTimeUsageDTO {
    /**
     * 
     * @type {number}
     * @memberof MonitoringTimeUsageDTO
     */
    last30DaysSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoringTimeUsageDTO
     */
    totalSeconds: number;
}

/**
 * Check if a given object implements the MonitoringTimeUsageDTO interface.
 */
export function instanceOfMonitoringTimeUsageDTO(value: object): value is MonitoringTimeUsageDTO {
    if (!('last30DaysSeconds' in value) || value['last30DaysSeconds'] === undefined) return false;
    if (!('totalSeconds' in value) || value['totalSeconds'] === undefined) return false;
    return true;
}

export function MonitoringTimeUsageDTOFromJSON(json: any): MonitoringTimeUsageDTO {
    return MonitoringTimeUsageDTOFromJSONTyped(json, false);
}

export function MonitoringTimeUsageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoringTimeUsageDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'last30DaysSeconds': json['last30DaysSeconds'],
        'totalSeconds': json['totalSeconds'],
    };
}

export function MonitoringTimeUsageDTOToJSON(value?: MonitoringTimeUsageDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'last30DaysSeconds': value['last30DaysSeconds'],
        'totalSeconds': value['totalSeconds'],
    };
}

